import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { SelectEl } from 'common/components/select';
export function template() {
  return jsx("span", null, !this.attr("is-select") ? jsx(ButtonEl, {
    attrs: {
      elref: "sharingStatusButton",
      theme: this.attr("theme"),
      disabled: this.helpers.isDisabled(),
      icon: "invite"
    },
    on: {
      click: this.helpers.handleClick
    }
  }, "Share") : jsx(SelectEl, {
    attrs: {
      elref: "sharingStatusMenu",
      theme: "primary",
      sections: JSON.stringify([{
        items: [{
          icon: "link",
          label: "Copy Link"
        }, {
          icon: "invite",
          label: "Manage Sharing",
          isDisabled: this.attr("disabled"),
          tooltip: {
            text: this.attr("tooltip-text"),
            placement: "left"
          }
        }]
      }]),
      'selected-option': "Share",
      'menu-width': 200
    },
    on: {
      change: this.helpers.handleMenuItemChange,
      menuChange: this.helpers.handleMenuChange
    }
  }));
}